import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import TextInput from "../../../../app/common/form/TextInput";
import CertificateFileDropzone from "./CertificateFileDropzone";
import { combineValidators, isRequired } from "revalidate";
import { toast } from "react-toastify";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  password: isRequired({ message: "La contraseña es obligatoria" }),
});

const CreateCertificateForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { postCertificate, btCreateCertificate, changeStatebtCreateCertificate } = rootStore.certificateStore;

  const [files, setFiles] = useState<any[]>([]);

  const [createCertificateForm] = useState({
    password: "",
    base64file: "",
  });

  const handleFinalFormSubmit = (values: any) => {  
    changeStatebtCreateCertificate();
    if (files.length > 0) {
      var f = files[0];
      var reader = new FileReader();
      reader.onload = (function (theFile) {
        return function (e: any) {
          var binaryData = e.target.result;
          var base64String = window.btoa(binaryData);
          postCertificate({
            password: values.password,
            base64file: base64String,
          });
        };
      })(f);
      reader.readAsBinaryString(f);
    } else {
      toast.error("Debe seleccionar un certificado");
    }
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={createCertificateForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Contraseña</label>
              <Field
                name="password"
                value={createCertificateForm.password}
                component={TextInput}
              />
              <label>
                Certificado:{" "}
                <strong>
                  {files.length > 0
                    ? files[0].path
                    : "No ha seleccionado ningún certificado"}
                </strong>{" "}
              </label>
              <Field name="base64file">
                {(props) => <CertificateFileDropzone setFiles={setFiles} />}
              </Field>
              <br />
              <br />
              <Button
                loading={btCreateCertificate}
                disabled={btCreateCertificate}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(CreateCertificateForm);
